export const getImageUrl = (url: string, stylename?: string) => {
  if (stylename) {
    return `${process.env.NEXT_PUBLIC_CDN_URL || ''}${url}?x-oss-process=style/${stylename}`;
  }

  return `${process.env.NEXT_PUBLIC_CDN_URL || ''}${url}`;
};
